import React, { useState, useContext, useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import classnames from "classnames";
import { useLocation } from 'react-router-dom'
import { useStores } from "../../core/stores/rootStore";
import { observe } from 'mobx'
import Logo from '../../assets/images/logo.svg';
import { useTranslation, Trans } from "react-i18next";
import { ControlledMenu, MenuItem, useClick, SubMenu, MenuDivider } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import { useNavigate, useParams} from 'react-router-dom';
//import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

const NavMenu = () => {
    let navigate = useNavigate();
    

    const { appStore, loginStore } = useStores();
    const { accountInfo } = loginStore;

    const initializeItems = () => {
        var items = [
            {
                name: t('timesheet'),
                icon: solid('table-columns'),
                to: "/timesheets",
            },

            {
                name: t('expensesInternal'),
                to: '/expenses/internal',
                icon: solid('money-bill'),
            },
            {
                name: t('documents'),
                to: '/documents',
                icon: solid('file'),
            },

            {
                name: t('reports'),
                to: '/reports',
                icon: solid('file-arrow-down'),
            },
            {
                name: t('masterData'),
                icon: solid('table'),
                root: '/administration',
                children: [
                    {
                        name: t("users"),
                        to: '/users',
                    },
                    {
                        name: t("clients"),
                        to: '/clients',
                    },
                    {
                        name: t("projects"),
                        to: '/projects',
                    },
                    {
                        name: t("activities"),
                        to: '/activities',
                    },
                ]
            },
            {
                name: t('administration'),
                icon: solid("gear"),
                root: '/administration',
                children: [

                    {
                        name: t("currencies"),
                        to: '/currencies',
                    },
                    {
                        name: t("countryCurrencies"),
                        to: '/country-currencies'
                    },

                    {
                        name: t("rates"),
                        to: '/rates',
                    },
                    { isDivider: true },
                    ////////////////////////

                    {
                        name: t("vats"),
                        to: '/vat',
                    },

                    {
                        name: t("expenseVats"),
                        to: '/expensevats'
                    },
                    { isDivider: true },
                    ////////////////////////

                    {
                        name: t("packageExpenses"),
                        to: '/package-expenses'
                    },
                    {
                        name: t("expensesWithCosts"),
                        to: '/expenses-with-costs'
                    },
                    { isDivider: true },
                    ////////////////////////

                    {
                        name: t("companies"),
                        to: '/companies',
                    },
                    { isDivider: true },
                    ////////////////////////

                    {
                        name: t("templates"),
                        to: '/templates',
                    },
                    { isDivider: true },
                    ////////////////////////

                    {
                        name: t("winbizCloud"),
                        to: '/winbiz',

                    },
                    {
                        name: t("emailSettings"),
                        to: '/email',
                    },
                ]
            },
        ];

        if (accountInfo.role === 2) {
            return items.slice(0, 1);
        }
        else if (accountInfo.role === 3) {
            return items.slice(0, 3);
        } else {
            return items.filter(x => x.to !== "/expenses/internal");
        }
    }

    const getCollapsedStatus = () => {
        var item = localStorage.getItem("app");
        var obj = JSON.parse(item);
        return obj?.sidebarCollapsed ?? false;
    }

    const location = useLocation();
    const [isCollapsed, setIsCollapsed] = useState(getCollapsedStatus());
    const toggleSidebar = () => setIsCollapsed(!isCollapsed);
    const { t, i18n } = useTranslation();
    const navItems = initializeItems();


    observe(appStore, "sidebarCollapsed", change => {
        setIsCollapsed(change.newValue)
    });


    
    const [isOpen, setOpen] = useState(false);    
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });


    const onMenuClick = (to) => {
        //alert(to)
        navigate(to);
        setOpen(null);        
    }

    const isActive = (path) => location.pathname.indexOf(path) > -1;
    const isParentActive = (nav) => nav?.children?.some(c => nav.root + c.to === location.pathname);
    

    return (
        <nav id="sidebar" className={classnames({ 'collapsed': isCollapsed })}>
            <div className="sidebar-header">
                {/*<FontAwesomeIcon className="nav-menu-bars cursor-pointer" icon={solid("bars")} size="2x" onClick={toggleSidebar}/>*/}
                {!isCollapsed && <span className="nav-menu-title">
                    <img src={Logo} width="100%" height="25px" alt="Logo" /><br />CH Finance
                </span>}
                {isCollapsed && <img src={Logo} width="40px" height="40px" alt="Logo" />}
            </div>
            <hr className="sidebar-divider" />
            <div className="sidebar-content">
                <ul className="nav nav-pills flex-column">
                    {navItems?.map((nav, index) => (
                        <li key={index} className="nav-item">
                            {!nav.children?.length && <Link to={nav.to} title={nav.name} className={classnames("nav-link", { 'active': location.pathname === nav.to, })}>
                                <FontAwesomeIcon icon={nav.icon} style={isCollapsed ? ({}) : { marginRight: '10px' }} size="lg" />
                                {!isCollapsed && nav.name}
                            </Link>}



                            {nav.children?.length &&
                                <div>
                                    <ControlledMenu

                                        state={isOpen == index ? "open" : "closed"}
                                        anchorPoint={anchorPoint}
                                        onClose={() => { setOpen(null); }}>
                                        {nav.children?.map((c, cIndex) => (
                                            <MenuItem /*onClick={(e) => { console.log(e); onMenuClick(nav.root + c.to) }}*/ key={cIndex}>
                                                <Link className={classnames("nav-link", { 'active': location.pathname === (nav.root + c.to), })} to={nav.root + c.to}>{c.name}</Link>
                                            </MenuItem>
                                        ))}
                                    </ControlledMenu>
                                    <div

                                        title={nav.name}
                                        data-bs-toggle="collapse"
                                        onClick={(e) => { if (isCollapsed && !isOpen) { setAnchorPoint({ x: e.clientX, y: e.clientY }); setOpen(index); } }}
                                        data-bs-target={"#menu" + index} className={classnames("nav-link", "nested", { navCollapsed: isCollapsed }, { 'active': isParentActive(nav), })} aria-expanded="false">
                                        <FontAwesomeIcon icon={nav.icon} style={isCollapsed ? ({ marginRight: 0 }) : { marginRight: '10px' }} size="lg" />
                                        {!isCollapsed && nav.name+""}



                                    </div></div>}
                            {!isCollapsed && nav.children?.length &&
                                <ul id={"menu" + index} className="collapse">
                                    {nav.children?.map((c, i) => {
                                        if (c.isDivider)
                                            return <MenuDivider key={i} />
                                        else {
                                            return < li key={i} className="nav-item py-1" >
                                                <Link to={nav.root + c.to} title={c.name} className={classnames("nav-sublink", { 'active': isActive(nav.root + c.to), })}>
                                                    {!isCollapsed && c.name}
                                                </Link>

                                            </li>
                                        }
                                    }

                                    )}
                                </ul>
                            }
                        </li>
                    ))}
                </ul>

            </div>

        </nav>
    );
};

export default NavMenu;
